/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_SourcesInputs */

const en_control_sources = /** @type {(inputs: Control_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sources & verification`)
};

const zh_control_sources = /** @type {(inputs: Control_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`来源与核验`)
};

/**
* | output |
* | --- |
* | "Sources & verification" |
*
* @param {Control_SourcesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_sources = /** @type {((inputs?: Control_SourcesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_SourcesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_sources(inputs)
	return zh_control_sources(inputs)
});
export { control_sources as "control.sources" }